(() => {
  const init = (controls) => {
    if (controls.dataset.ready === 'true') return;
    const section = controls.closest('section');
    const track = section && section.querySelector('[data-cb-carousel-track]');
    const previous = controls.querySelector('[data-cb-prev]');
    const next = controls.querySelector('[data-cb-next]');
    const dots = controls.querySelector('[data-cb-dots]');
    if (!track || !previous || !next || !dots) return;
    controls.dataset.ready = 'true';
    let pageCount = 1;
    let timer;
    const pageWidth = () => Math.max(track.clientWidth, 1);
    const currentPage = () => Math.min(pageCount - 1, Math.max(0, Math.round(track.scrollLeft / pageWidth())));
    const update = () => {
      const activePage = currentPage();
      dots.querySelectorAll('button').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activePage);
        dot.setAttribute('aria-current', index === activePage ? 'true' : 'false');
      });
      previous.disabled = activePage === 0;
      next.disabled = activePage === pageCount - 1;
    };
    const buildDots = () => {
      pageCount = Math.max(1, Math.ceil(track.scrollWidth / pageWidth()));
      dots.replaceChildren();
      for (let index = 0; index < pageCount; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cb-carousel-dot';
        dot.setAttribute('aria-label', `Go to page ${index + 1}`);
        dot.addEventListener('click', () => track.scrollTo({ left: index * pageWidth(), behavior: 'smooth' }));
        dots.appendChild(dot);
      }
      update();
    };
    previous.addEventListener('click', () => track.scrollBy({ left: -pageWidth(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: pageWidth(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(update, 80); }, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();
  };
  const initAll = () => document.querySelectorAll('[data-cb-carousel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
